<script setup lang="ts">
const route = useRoute()
const {filterCity, filterType, loadGeoLocation, geolocation} = useNavSearch()

const useMyAnyWhere = () => {
  filterType.value = 'Qualquer Lugar'
  filterCity.value = null
  geolocation.value.latitude = null
  geolocation.value.longitude = null
}

const filterMyCity = () => {
  if (!filterCity.value) {
    filterType.value = 'Qualquer Lugar'
    return;
  }
  filterType.value = capitalize(filterCity.value)
}

</script>

<template>
  <form id="search-main-input" class="form-group form-group-light d-block rounded-xl-pill w-100"
        method="get" action="/eventos" style="padding: 0 10px">
    <div class="row align-items-center g-0 ms-n2">
      <div class="col-md-7">
        <div class="input-group input-group-sm border-end-md border-light">
          <span class="input-group-text text-light rounded-pill opacity-50 ps-3 d-block d-md-none"><i
              class="fi-search"></i></span>
          <input class="form-control form-control-sm" type="text" name="q" :value="route?.query?.q"
                 placeholder="Pesquisar eventos, shows, teatros, cursos..."/>
        </div>
      </div>
      <div class="col-md-4 d-sm-flex">
        <div class="dropdown w-sm-50 border-light" data-bs-toggle="select">
          <button class="btn btn-sm btn-link dropdown-toggle" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
            <i class="fi-map-pin me-1"></i><span class="dropdown-toggle-label">{{ filterType }}&nbsp;</span>
          </button>
          <ul class="dropdown-menu dropdown-menu-dark my-3" id="main-location-search" style="top: 20px">
            <li class="dropdown-header"><b>Ver experiencias em</b></li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" @click="useMyAnyWhere">
                <i class="fi-map-pin me-2"></i>Qualquer lugar
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" @click="loadGeoLocation">
                <i class="fi-map-pin me-1"></i> Usar minha localização atual
              </a>
            </li>
            <li class="dropdown-header"><b>OU</b></li>
            <li class="li-input-search">
              <input class="form-control border-2 border-light" v-model="filterCity" type="search"
                     placeholder="Buscar cidades"
                     @blur="filterMyCity"/>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-1 d-sm-flex align-items-center">
        <button class="btn rounded-pill btn-primary btn-sm ms-2 w-100 mb-2 mb-sm-0" type="submit">
          <i class="fi-search" style="margin: 1px auto"></i>
          <span class="d-block d-md-none">Buscar</span>
        </button>
      </div>
    </div>
  </form>
</template>
